<template>
  <div>
    <back-button default-to="/stock-adjustments"/>
    <b-card no-header no-footer>
      <ValidationObserver ref="form">
        <form @submit.prevent="save('draft')">
          <b-row>
            <b-col cols="12" md="4"><form-group-input ref="tanggal_penyesuaian" type="date" label="Tanggal Penyesuaian" :need-label="true" v-model="model.tanggal_penyesuaian.value" rules="required" id="tanggal_penyesuaian" /></b-col>
            <b-col cols="12" md="4"><form-group-input ref="jenis" type="enum" label="Jenis" :need-label="true" :options="getOptions('jenis')" v-model="model.jenis.value" rules="required" id="jenis" /></b-col>
          </b-row>
          <div class="mt-2 mb-3">
            <h5>Detail Barang</h5>
            <b-btn variant="dark" @click.prevent="openStockModal"><font-awesome-icon icon="plus" /> Tambah Barang</b-btn>
            <div class="table-responsive mt-3"><table class="table table-striped"><thead><tr><th>Nama</th><th>Berat</th><th>Kadar</th><th>Jumlah</th><th>Pratinjau Dampak</th><th></th></tr></thead><tbody>
              <tr v-if="!details.length"><td colspan="6" class="text-center text-muted">Belum ada barang.</td></tr>
              <tr v-for="(row, index) in details" :key="row.key"><td>{{ row.nama }}</td><td>{{ row.berat }} gram</td><td>{{ row.kadar || '-' }}</td><td><b-form-input v-model="row.qty" type="number" min="1" /></td><td><small class="text-muted">{{ previewRow(row) }}</small></td><td><b-button @click.prevent="removeRow(index)" variant="danger" size="sm"><font-awesome-icon icon="trash"/></b-button></td></tr>
            </tbody></table></div>
            <p class="text-muted small mb-0">Pratinjau bersifat perkiraan. Saldo akhir dihitung ulang saat persetujuan.</p>
          </div>
          <form-group-input ref="alasan" type="textarea" label="Alasan" :need-label="true" v-model="model.alasan.value" rules="required" id="alasan" />
          <b-button v-if="mode === 'create' || transactionStatus === 'draft'" type="button" variant="primary" :disabled="isLoading" @click="save('pending')">Ajukan Persetujuan</b-button>
          <b-button type="submit" variant="secondary" class="ml-2" :disabled="isLoading"><font-awesome-icon icon="spinner" spin v-if="isLoading"/> {{ mode === 'update' ? 'Simpan Perubahan' : 'Simpan Draft' }}</b-button>
          <b-button to="/stock-adjustments" variant="secondary" class="ml-3 float-right">Batal</b-button>
        </form>
      </ValidationObserver>
    </b-card>
    <b-modal id="stock-adjustment-add-modal" title="Pilih Stok" hide-footer>
      <b-input class="w-100 mb-3" placeholder="Ketik minimal 2 karakter: barcode atau nama" v-model="stockSearch" />
      <b-spinner v-if="stockLoading" small label="Memuat" />
      <div v-else-if="stocks.length" class="list-group">
        <a href="#" @click.prevent="selectStock(stock)" v-for="stock in stocks" :key="stock.id" class="list-group-item list-group-item-action">
          <strong>[{{ stock.stock_barcode }}] {{ stock.nama }}</strong><small class="d-block text-muted">{{ stock.jenis_barang }} · {{ stock.kadar || '-' }} · saldo {{ formatBalance(stock) }}</small>
        </a>
      </div>
      <p v-else class="text-center text-muted">{{ pickerMessage }}</p>
      <div class="mt-3 text-center"><b-button v-if="stockPage > 1" size="sm" @click="loadStocks(stockPage - 1)">Sebelumnya</b-button><b-button v-if="stocks.length === 20" size="sm" class="ml-2" @click="loadStocks(stockPage + 1)">Berikutnya</b-button></div>
    </b-modal>
  </div>
</template>

<script>
import { saveProcess, objectToOptions, setModelValue } from '@/_helpers'
import formGroupInput from '@/components/FormGroupInput.vue'
import StockAdjustment from '@/models/StockAdjustment.js'
import Stock from '@/models/Stock.js'

const stockAdjustmentModel = new StockAdjustment()
const stockModel = new Stock()
let searchTimer = null

export default {
  components: { formGroupInput },
  data () { return { isLoading: false, model: stockAdjustmentModel.init(), details: [], stocks: [], stockSearch: '', stockLoading: false, stockPage: 1, transactionStatus: 'draft' } },
  computed: {
    mode () { return this.$route.params.id ? 'update' : 'create' },
    pickerMessage () { return this.stockSearch.length < 2 ? 'Ketik minimal 2 karakter untuk mencari.' : 'Stok tidak ditemukan.' }
  },
  watch: {
    stockSearch () { clearTimeout(searchTimer); searchTimer = setTimeout(() => { this.loadStocks(1) }, 350) }
  },
  mounted () {
    if (this.mode === 'update') this.getDetail()
    else {
      this.model.tanggal_penyesuaian.value = this.$moment().format('YYYY-MM-DD')
      this.$nextTick(() => this.$refs.tanggal_penyesuaian.setValue(this.model.tanggal_penyesuaian.value))
      if (this.$route.query.stock_id) this.prefillStock(this.$route.query.stock_id)
    }
  },
  methods: {
    getOptions (key) { return objectToOptions(this.model[key].options) },
    getDetail () {
      this.isLoading = true
      stockAdjustmentModel.find(this.$route.params.id).then(data => {
        if (data.approval_status !== 'draft') { this.$store.dispatch('notification/error', 'Hanya Penyesuaian Stok draft yang dapat diubah.'); this.$router.replace('/stock-adjustments/' + data.id); return }
        this.transactionStatus = data.approval_status
        setModelValue(this.model, data, true)
        this.details = (data.detail_barang || []).map(item => ({ ...item, key: item.id }))
        this.details.forEach(row => this.refreshRowBalance(row))
      }).catch(error => this.$store.dispatch('notification/error', error)).finally(() => { this.isLoading = false })
    },
    prefillStock (stockId) {
      stockModel.find(stockId).then(stock => { this.pushRow(stock) }).catch(error => this.$store.dispatch('notification/error', error))
    },
    refreshRowBalance (row) {
      stockModel.find(row.stock_id).then(stock => {
        row.inventory_unit = stock.inventory_unit
        row.stock_balance = stock.stock_balance
        row.sisa_stok = stock.sisa_stok
        row.berat = stock.berat
      }).catch(() => {})
    },
    openStockModal () { this.stockSearch = ''; this.stocks = []; this.stockPage = 1; this.$bvModal.show('stock-adjustment-add-modal') },
    loadStocks (page) {
      if (this.stockSearch.length < 2) { this.stocks = []; return }
      this.stockLoading = true; this.stockPage = page
      stockModel.list({ nama_barcode: this.stockSearch, limit: 20, page, order: 'nama', ascending: 1 }).then(response => { this.stocks = response.data.data || [] }).catch(error => this.$store.dispatch('notification/error', error)).finally(() => { this.stockLoading = false })
    },
    formatAmount (unit, amount) {
      const value = Number(amount || 0)
      return unit === 'gram'
        ? value.toLocaleString('id-ID', { minimumFractionDigits: 3, maximumFractionDigits: 3 }) + ' gram'
        : value.toLocaleString('id-ID', { maximumFractionDigits: 0 }) + ' buah'
    },
    formatBalance (stock) { return this.formatAmount(stock.inventory_unit, stock.stock_balance) },
    previewRow (row) {
      if (typeof row.stock_balance === 'undefined' || row.stock_balance === null || !this.model.jenis.value) return '-'
      const qty = Number(row.qty || 0)
      const unit = row.inventory_unit === 'gram' ? 'gram' : row.inventory_unit
      const delta = row.inventory_unit === 'gram' ? Number(row.berat || 0) * qty : qty
      const sign = this.model.jenis.value === 'tambah' ? 1 : -1
      const balance = Number(row.stock_balance || 0)
      const pieces = Number(row.sisa_stok || 0)
      const before = this.formatAmount(unit, balance) + ' / ' + pieces + ' buah'
      const after = this.formatAmount(unit, balance + sign * delta) + ' / ' + (pieces + sign * qty) + ' buah'
      return before + ' → ' + after
    },
    pushRow (stock) {
      if (this.details.find(row => Number(row.stock_id) === Number(stock.id))) { this.$store.dispatch('notification/error', 'Barang sudah ditambahkan.'); return false }
      this.details.push({ key: Date.now() + Math.random(), stock_id: stock.id, nama: stock.nama, jenis_barang: stock.jenis_barang, berat: stock.berat, kadar: stock.kadar, inventory_unit: stock.inventory_unit, stock_balance: stock.stock_balance, sisa_stok: stock.sisa_stok, qty: 1 })
      return true
    },
    selectStock (stock) {
      if (this.pushRow(stock)) this.$bvModal.hide('stock-adjustment-add-modal')
    },
    removeRow (index) { this.details.splice(index, 1) },
    validateDetails () { if (!this.details.length) return 'Minimal satu barang wajib diisi.'; return this.details.some(row => !row.stock_id || !row.qty || Number(row.qty) < 1) ? 'Setiap barang harus memiliki jumlah minimal 1.' : null },
    save (status) {
      const detailError = this.validateDetails(); if (detailError) { this.$store.dispatch('notification/error', detailError); return }
      this.$refs.form.validate().then(valid => {
        if (!valid || this.isLoading) return
        this.isLoading = true
        saveProcess(this.model, this.mode === 'update').then(model => {
          model.details = this.details.map(row => ({ stock_id: row.stock_id, qty: row.qty }))
          if (this.mode === 'update') return stockAdjustmentModel.update(this.$route.params.id, model).then(data => status === 'pending' && this.transactionStatus === 'draft' ? stockAdjustmentModel.submit(data.id) : data)
          model.approval_status = status; return stockAdjustmentModel.create(model)
        }).then(data => { this.$store.dispatch('notification/success', status === 'pending' ? 'Penyesuaian Stok berhasil diajukan.' : 'Draft Penyesuaian Stok berhasil disimpan.'); this.$router.push('/stock-adjustments/' + data.id) }).catch(error => this.$store.dispatch('notification/error', error)).finally(() => { this.isLoading = false })
      })
    }
  }
}
</script>
